import { render } from "./ImpactComponent.vue?vue&type=template&id=f0fe76a8&scoped=true"
import script from "./ImpactComponent.vue?vue&type=script&lang=js"
export * from "./ImpactComponent.vue?vue&type=script&lang=js"

import "./ImpactComponent.vue?vue&type=style&index=0&id=f0fe76a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0fe76a8"]])

export default __exports__